import CodeSnippetBlock from "ds/components/CodeSnippetBlock";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";

type ModuleVersionInputsCodeDrawerProps = {
  code: string;
  title: string;
};

const ModuleVersionInputsCodeDrawer = createDrawer(
  ({ code, title }: ModuleVersionInputsCodeDrawerProps) => {
    return (
      <DrawerSimple variant="wide">
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title={title} />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <CodeSnippetBlock allowCopy>{code}</CodeSnippetBlock>
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showModuleVersionInputsCodeDrawer = createDrawerTrigger(ModuleVersionInputsCodeDrawer);
